import api from '../callApi';

const apiInitiateVoteRegistration = (apiRequestData, id, state, dateOfBirth) => {
    const request = {
        ...apiRequestData,
        id,
        state,
        dateOfBirth
    };

    return api.post('Widget/InitiateVoteRegistrationAsync', request).then(response => {
        return response;
    });
};

export default apiInitiateVoteRegistration;



// WEBPACK FOOTER //
// ./src/utils/voteRegistration/voteRegistrationInitiateApi.js